var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNfTinger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.131,
    height: 39.729,
    viewBox: "0 0 153.131 39.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2e1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0bbdf2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(-132.636 -5171.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    transform: "translate(89 5156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1178",
    "data-name": "Rectangle 1178",
    width: 28.466,
    height: 27.72,
    rx: 3,
    transform: "translate(43.636 35.693) rotate(-45)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1177",
    "data-name": "Rectangle 1177",
    width: 28.466,
    height: 27.72,
    rx: 3,
    transform: "translate(46.794 46.18) rotate(-77)",
    fill: "#dba343"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(52 24)",
    fill: "#031527"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1176",
    "data-name": "Rectangle 1176",
    width: 12.067,
    height: 12.067,
    rx: 2,
    transform: "translate(55.039 35.43) rotate(-45)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M-52.141-13.737h2.786l8.561,4.482v-4.482h2.786V0h-2.786V-6.3l-8.561-4.456V0h-2.786Zm18.018,0h12.287v2.443h-9.5V-7.7h8.068v2.294h-8.068V0h-2.786Zm19.116,2.443h-5.071v-2.443H-7.15v2.443h-5.071V0h-2.786Zm11.874-.492a2.094,2.094,0,0,1-.7-.11,1.642,1.642,0,0,1-.532-.3,1.322,1.322,0,0,1-.338-.439,1.227,1.227,0,0,1-.119-.532,1.247,1.247,0,0,1,.119-.541,1.278,1.278,0,0,1,.338-.435,1.69,1.69,0,0,1,.532-.294,2.094,2.094,0,0,1,.7-.11,2.123,2.123,0,0,1,.708.11,1.69,1.69,0,0,1,.532.294,1.278,1.278,0,0,1,.338.435,1.247,1.247,0,0,1,.119.541,1.227,1.227,0,0,1-.119.532,1.322,1.322,0,0,1-.338.439,1.642,1.642,0,0,1-.532.3A2.123,2.123,0,0,1-3.133-11.786Zm-1.3,1.415h2.6V0h-2.6Zm5.933,0H4.1v.879a7.992,7.992,0,0,1,1.982-.826,7.578,7.578,0,0,1,1.85-.237,6.722,6.722,0,0,1,2.2.347,4.851,4.851,0,0,1,1.749,1.033,4.73,4.73,0,0,1,1.156,1.709A6.239,6.239,0,0,1,13.452-5.1V0H10.859V-4.676A4.49,4.49,0,0,0,10.617-6.2a3.081,3.081,0,0,0-.694-1.134,2.976,2.976,0,0,0-1.1-.7,4.1,4.1,0,0,0-1.446-.242,4.452,4.452,0,0,0-.866.088,5.357,5.357,0,0,0-.87.25,4.97,4.97,0,0,0-.822.4,4.331,4.331,0,0,0-.721.549V0H1.5ZM18.268,1.758a9.131,9.131,0,0,0,1,.294q.51.119.989.193t.918.105q.439.031.782.031a5.847,5.847,0,0,0,1.806-.25,3.909,3.909,0,0,0,1.283-.672,2.728,2.728,0,0,0,.769-.98A2.813,2.813,0,0,0,26.073-.7v-.448a5.641,5.641,0,0,1-.782.439,6.891,6.891,0,0,1-.984.369,9.143,9.143,0,0,1-1.138.255,7.834,7.834,0,0,1-1.244.1,7.018,7.018,0,0,1-2.355-.382A5.71,5.71,0,0,1,17.7-1.446,4.866,4.866,0,0,1,16.462-3.1a5.079,5.079,0,0,1-.444-2.145,5.023,5.023,0,0,1,.466-2.184,4.946,4.946,0,0,1,1.288-1.674,5.882,5.882,0,0,1,1.947-1.072,7.628,7.628,0,0,1,2.443-.378,8.852,8.852,0,0,1,1.116.07,9.574,9.574,0,0,1,1.059.193,7.673,7.673,0,0,1,.949.294,5.328,5.328,0,0,1,.787.374v-.747h2.6v9.185a6.78,6.78,0,0,1-.431,2.5,4.767,4.767,0,0,1-1.261,1.833,5.484,5.484,0,0,1-2.061,1.125,9.512,9.512,0,0,1-2.821.382q-.571,0-1.187-.048t-1.235-.141q-.62-.092-1.222-.22T17.3,3.955Zm.483-7.031A2.8,2.8,0,0,0,19-4.1a2.819,2.819,0,0,0,.716.958,3.4,3.4,0,0,0,1.125.642,4.44,4.44,0,0,0,1.485.233,5.706,5.706,0,0,0,1.068-.1,6.087,6.087,0,0,0,1.02-.286A5.294,5.294,0,0,0,25.33-3.1a3.869,3.869,0,0,0,.743-.589V-7.11a4.7,4.7,0,0,0-.835-.536,5.848,5.848,0,0,0-.9-.36,5.985,5.985,0,0,0-.923-.207,6.46,6.46,0,0,0-.905-.066,4.95,4.95,0,0,0-1.6.237A3.551,3.551,0,0,0,19.74-7.4a2.809,2.809,0,0,0-.734.954A2.725,2.725,0,0,0,18.751-5.273Zm12.393.053a4.884,4.884,0,0,1,.431-2.017,5.116,5.116,0,0,1,1.239-1.7A6.044,6.044,0,0,1,34.8-10.116a7.568,7.568,0,0,1,2.667-.439,7.62,7.62,0,0,1,2.676.444,6,6,0,0,1,2.021,1.217,5.274,5.274,0,0,1,1.274,1.819,5.677,5.677,0,0,1,.444,2.241q0,.149,0,.321t-.022.312H34.044a2.376,2.376,0,0,0,.541.853,3.4,3.4,0,0,0,.936.668,5.337,5.337,0,0,0,1.3.435,8.032,8.032,0,0,0,1.635.154,8.547,8.547,0,0,0,1.784-.189,13.092,13.092,0,0,0,1.7-.479l.879,1.986a10.721,10.721,0,0,1-1.033.417,9.007,9.007,0,0,1-1.09.3,11.187,11.187,0,0,1-1.187.18q-.62.062-1.305.062a10.081,10.081,0,0,1-3.067-.422,6.6,6.6,0,0,1-2.206-1.151A4.753,4.753,0,0,1,31.592-3.1,5.05,5.05,0,0,1,31.144-5.221ZM41.12-6.231a2.593,2.593,0,0,0-.435-.8,2.872,2.872,0,0,0-.734-.65,3.754,3.754,0,0,0-1.02-.435,4.835,4.835,0,0,0-1.274-.158,5.06,5.06,0,0,0-1.345.167,4.091,4.091,0,0,0-1.063.448,3.019,3.019,0,0,0-.76.65,2.5,2.5,0,0,0-.444.782Zm5.555-4.14h2.6v1.494A11.342,11.342,0,0,1,51.1-9.984,10.24,10.24,0,0,1,53-10.7l.765,2.382a8.255,8.255,0,0,0-2.641.672,4.74,4.74,0,0,0-1.85,1.472V0h-2.6Z",
    transform: "translate(232 5198)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfTinger);
export default __webpack_public_path__ + "static/media/NFTinger.bc80e2f63a12520c74c610361e423822.svg";
export { ForwardRef as ReactComponent };